import {Component, OnInit} from '@angular/core';
import {Message} from '../../model/message';
import {GymChatService} from '../../services/gym-chat.service';
import {AlertController, ModalController, ToastController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../services/auth.service';
import {GymService} from '../../services/gym.service';
import {GuestService} from '../../services/guest-service';
import {GuestInfoComponent} from '../../components/guest-info/guest-info.component';
import {MatomoTracker} from 'ngx-matomo-client';

const INFINITE_SCROLL_STEP = 20;

@Component({
  selector: 'app-gym-chat',
  templateUrl: './gym-chat.page.html',
  styleUrls: ['./gym-chat.page.scss'],
})
export class GymChatPage implements OnInit {

  allMessages: Message[];
  visibleMessages: Message[];

  constructor(
    private matomoTracker: MatomoTracker,
    private modalCtrl: ModalController,
    private gymService: GymService,
    private toastController: ToastController,
    public authService: AuthService,
    private alertController: AlertController,
    private translate: TranslateService,
    private guestService: GuestService,
    private gymChatService: GymChatService) {
  }

  ionViewWillEnter() {
    this.reloadMessages();
    this.matomoTracker.trackPageView('chat');
  }

  ngOnInit() {
  }

  private async reloadMessages() {
    this.resetMessages();
    await this.gymService.syncActiveGym();
    this.gymChatService.loadMessagesAndUpdateNumUnread().subscribe(messages => {
      this.allMessages = messages;
      this.visibleMessages = this.allMessages.slice(0, INFINITE_SCROLL_STEP);
      this.gymChatService.markChatForActiveGymAsVisited();
    });
  }

  private resetMessages() {
    this.allMessages = null;
    this.visibleMessages = null;
  }

  async addMessage() {
    if (this.guestService.isGuest()) {
      GuestInfoComponent.showAsModal(this.modalCtrl);
      return;
    }
    const alert = await this.alertController.create({
      header: this.translate.instant('gym-chat-page.write-a-message'),
      cssClass: 'message-alert',
      mode: 'md',
      inputs: [
        {
          name: 'message',
          type: 'textarea',
          cssClass: 'message',
          placeholder: this.translate.instant('gym-chat-page.your-message')
        }
      ],
      buttons: [
        {
          text: this.translate.instant('shared.cancel'),
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          cssClass: 'primary',
          text: this.translate.instant('gym-chat-page.send'),
          handler: (data) => {
            if (data?.message.length < 3) {
              this.showMinLengthToast();
              return false;
            } else {
              this.createNewMessage(data.message);
              return true;
            }
          }
        }
      ]
    });
    await alert.present();
  }

  private async createNewMessage(message: string) {
    this.resetMessages();
    await this.gymChatService.createMessage(message);
    await this.reloadMessages();
  }

  async deleteMessage(messageId: string) {
    const alert = await this.alertController.create({
      header: this.translate.instant('gym-chat-page.delete-this-message'),
      cssClass: 'message-alert',
      mode: 'md',
      buttons: [
        {
          text: this.translate.instant('shared.cancel'),
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {

          }
        }, {
          text: this.translate.instant('gym-chat-page.yes-delete'),
          handler: async () => {
            this.resetMessages();
            await this.gymChatService.deleteMessage(messageId);
            this.reloadMessages();
          }
        }
      ]
    });
    await alert.present();
  }

  private async showMinLengthToast() {
    const toast = await this.toastController.create({
      color: 'danger',
      duration: 3000,
      message: this.translate.instant('gym-chat-page.min-3-letters'),
      position: 'top'
    });
    await toast.present();
  }


  async onRefresh() {
    this.reloadMessages();
  }

  listMessages(event) {
    setTimeout(() => {
      event.target.complete();
      this.visibleMessages = this.visibleMessages.concat(
        this.allMessages.slice(this.visibleMessages.length, this.visibleMessages.length + INFINITE_SCROLL_STEP));
    }, 500);
  }
}
